import Icon from '@material-ui/icons/Dashboard'
import { ROLES } from 'utils/user'

export default {
  icon: Icon,
  permissions: [ROLES.ROLE_ADMIN],
}
